import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AdminLayout } from "../layouts";
import {
  Auth,
  Users,
  Blog,
  Courses,
  Menu,
  Newsletter,
  Assistance,
  VirtualScenes,
  UsersDB,
  ClientDBcreator,
  ClientDB,
  Page_Partner_Profile,
  Page_Partner_Institution,
  MozillaHubRooms,
  Page_PlanesEduca,
  Page_Billings,
} from "../pages/admin";
import { TiptapTestPage } from "../pages/admin/Tiptap/TiptapTestPage";
import { useAuth } from "../hooks";

export function AdminRouter() {
  const { user, login } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fromUnity = params.get("fromUnity");
    const tokenFromUrl = params.get("token");
    const userFromUrl = params.get("user");

    //console.log("fromUnity:", fromUnity);
    //console.log("Token desde la URL:", tokenFromUrl);
    //console.log("Datos del usuario desde la URL:", userFromUrl);

    if (fromUnity === "true") {
      if (tokenFromUrl && userFromUrl) {
        try {
          // Guardar los datos en localStorage para futuras sesiones
          localStorage.setItem("accessToken", tokenFromUrl);
          localStorage.setItem("user", userFromUrl);

          // Parsear los datos del usuario
          const parsedUser = JSON.parse(decodeURIComponent(userFromUrl));
          console.log("Usuario parseado desde la URL:", parsedUser);

          // Llamar al método `login` con los datos obtenidos
          login(tokenFromUrl, parsedUser);
        } catch (error) {
          console.error(
            "Error al procesar datos del usuario desde la URL:",
            error,
          );
        }
      } else {
        console.error(
          "No se encontraron datos en la URL. Verificando localStorage...",
        );

        const token = localStorage.getItem("accessToken");
        const userData = localStorage.getItem("user");

        //console.log("Token desde localStorage:", token);
        //console.log("Datos del usuario desde localStorage:", userData);

        if (token && userData) {
          const parsedUser = JSON.parse(userData);
          login(token, parsedUser);
        }
      }
    }
  }, [location, login]);

  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  return (
    <Routes>
      {!user ? (
        <Route path="*" element={<Auth />} />
      ) : (
        <>
          <Route
            path="tiptap-test" // <-- 2. AJUSTA EL PATH PARA QUE SEA RELATIVO
            element={loadLayout(AdminLayout, TiptapTestPage)}
          />
          {/* Todas las rutas de administración */}
          <Route path="blog" element={loadLayout(AdminLayout, Blog)} />
          <Route
            path="planes"
            element={loadLayout(AdminLayout, Page_PlanesEduca)}
          />
          <Route
            path="billings"
            element={loadLayout(AdminLayout, Page_Billings)}
          />
          <Route path="users" element={loadLayout(AdminLayout, Users)} />
          <Route path="courses" element={loadLayout(AdminLayout, Courses)} />
          <Route path="menu" element={loadLayout(AdminLayout, Menu)} />
          <Route
            path="newsletter"
            element={loadLayout(AdminLayout, Newsletter)}
          />
          <Route
            path="salas"
            element={loadLayout(AdminLayout, MozillaHubRooms)}
          />
          <Route
            path="virtualscenes"
            element={loadLayout(AdminLayout, VirtualScenes)}
          />
          <Route
            path="assistance"
            element={loadLayout(AdminLayout, Assistance)}
          />
          <Route path="usersdb" element={loadLayout(AdminLayout, UsersDB)} />
          <Route
            path="clientdbcreator"
            element={loadLayout(AdminLayout, ClientDBcreator)}
          />
          <Route path="clientdb" element={loadLayout(AdminLayout, ClientDB)} />
          <Route
            path="register"
            element={loadLayout(AdminLayout, Page_Partner_Profile)}
          />
          <Route
            path="institution"
            element={loadLayout(AdminLayout, Page_Partner_Institution)}
          />
          <Route path="*" element={loadLayout(AdminLayout, Blog)} />{" "}
          {/* Ruta por defecto para /admin */}
        </>
      )}
    </Routes>
  );
}
